var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmIcon05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(-859 -3220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(-430 1806)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1289 1414)",
    fill: "#fd0000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(1297 1422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26844",
    "data-name": "Path 26844",
    d: "M106.735-40.662a1,1,0,0,0-1,1,1,1,0,0,0,1,1.005,1,1,0,0,0,1-1.005A1,1,0,0,0,106.735-40.662Z",
    transform: "translate(-94.539 43.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26845",
    "data-name": "Path 26845",
    d: "M102.267-39.373a4.227,4.227,0,0,0-4.222,4.222,4.227,4.227,0,0,0,4.222,4.222,4.227,4.227,0,0,0,4.222-4.222A4.227,4.227,0,0,0,102.267-39.373Zm0,6.926a2.707,2.707,0,0,1-2.705-2.7,2.707,2.707,0,0,1,2.705-2.7,2.707,2.707,0,0,1,2.7,2.7A2.707,2.707,0,0,1,102.267-32.447Z",
    transform: "translate(-94.205 42.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26846",
    "data-name": "Path 26846",
    d: "M104.818-28.149H98.43a4.749,4.749,0,0,1-4.806-4.678v-6.218a4.749,4.749,0,0,1,4.806-4.677h6.387a4.749,4.749,0,0,1,4.806,4.677v6.218A4.749,4.749,0,0,1,104.818-28.149ZM98.43-42.258a3.261,3.261,0,0,0-3.3,3.212v6.218a3.262,3.262,0,0,0,3.3,3.213h6.387a3.261,3.261,0,0,0,3.3-3.213v-6.218a3.261,3.261,0,0,0-3.3-3.212Z",
    transform: "translate(-93.624 43.723)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmIcon05);
export default __webpack_public_path__ + "static/media/sm-icon-05.30c929fdf67d6736524a5255facdcfbf.svg";
export { ForwardRef as ReactComponent };